export enum ETypeUser {
  ADMIN = 1,
  TEACHER = 2,
  STUDENT = 3
}
